import { OverrideSitemodels } from 'locales/types'
import { useTranslation } from 'react-i18n-lite'

const useLocales = () => {
  const { language } = useTranslation()

  const getSitemodelByLocale = ({ demand }: { demand: string }) => {
    const overrideSitemodels: OverrideSitemodels | undefined =
      globalThis.overrideSitemodels

    if (
      !overrideSitemodels ||
      !overrideSitemodels[language] ||
      !overrideSitemodels[language][demand]
    ) {
      return `${globalThis[demand as keyof typeof globalThis] as string}`
    }

    return `${overrideSitemodels?.[language]?.[demand]}`
  }

  return {
    getSitemodelByLocale
  }
}

export default useLocales
